import script from "./communityList.vue?vue&type=script&lang=ts&setup=true"
export * from "./communityList.vue?vue&type=script&lang=ts&setup=true"

import "./communityList.vue?vue&type=style&index=0&id=e23debd8&lang=less"

const __exports__ = script;

export default __exports__